import { Feature } from "features/interfaces";
import page from "./_ErrorPage/_ErrorPage";

export const errorFeature: Feature = {
  page
};
